import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// Legacy /activate route — pre-pivot users were routed here for the $100
// PayPal fee. Now everyone is auto-activated in demo mode at signup, so we
// just bounce them straight to the dashboard.
export default function Activate() {
  const { user, refresh } = useAuth();
  useEffect(() => { refresh && refresh(); }, [refresh]);
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}
